module.exports = __webpack_public_path__ + "static/media/sparrow.f9f7fd67.png";